import { render, staticRenderFns } from "./_tabManageCompany.vue?vue&type=template&id=4562ae3a&scoped=true"
import script from "./_tabManageCompany.vue?vue&type=script&lang=js"
export * from "./_tabManageCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4562ae3a",
  null
  
)

export default component.exports